import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { usePageStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function PageGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid />
}

export default function PageGridLayout() {
  return <GridProvider store={usePageStore()}>
    <PageGrid />
  </GridProvider>
}
